import { useEffect } from 'react';
import usermanager from '../usermanager/oidc-client-usermanager';

/**
 * Components which process response from the authorization endpoint.
 *The result of the promise is the authenticated User
 */

const SignInCallback = ({ history }) => {
  useEffect(() => {
    const processSignInResult = async () => {
      const user = await usermanager.signinRedirectCallback();
      history.push(user.state.url);
    };
    processSignInResult();
  }, [history]);
  return <p>Please Wait...</p>;
};

export default SignInCallback;
